var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcentration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_32_163)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 67,
    height: 67,
    rx: 11.5,
    fill: "#3EC6CA",
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 42.2H34.8V48H40.6V42.2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 18.9999H34.8V24.7999H40.6V18.9999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 36.4001H29V42.2001H34.8V36.4001Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 36.4001H40.6V42.2001H46.4V36.4001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8 24.8H29V30.6001H34.8V24.8Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 30.5999H34.8V36.3999H40.6V30.5999Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4 24.8H40.6V30.6001H46.4V24.8Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2 10H23.2C21.4329 10 20 11.4328 20 13.2V53.8C20 55.5671 21.4328 57 23.2 57H52.2001C53.9672 57 55.4001 55.5672 55.4001 53.8V13.2C55.4 11.4328 53.9672 10 52.2 10ZM52.2 18.9999H46.4V24.8H52.2V30.6H46.4V36.4H52.2V42.2H46.4V48H52.2V53.8H46.4V48H40.6V53.8H34.8V48H28.9999V53.8H23.2V48H28.9999L29 42.2H23.2V36.4H29V30.6H23.2V24.8H29V18.9999H23.2V13.2H29V18.9999L34.8 19V13.2H40.6V19H46.4V13.2H52.2001V18.9999H52.2Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_32_163",
    x: 0,
    y: 0,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_32_163"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_32_163",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcentration);
export default __webpack_public_path__ + "static/media/concentration.04d0a876bd5761cfca5b052058ba6722.svg";
export { ForwardRef as ReactComponent };